import { Box, SxProps, Theme } from '@mui/material'
import { FC, ReactNode } from 'react'

export const TAB_CONTENT_MAX_HEIGHT = 'calc(100vh - 220px)'

const scrollSx = {
  overflowY: 'auto' as const,
  overflowX: 'hidden' as const,
  pr: 0.5,
  scrollbarWidth: 'thin' as const,
  '&::-webkit-scrollbar': {
    width: 6,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0,0,0,0.2)',
    borderRadius: 3,
  },
}

interface ITabScrollAreaProps {
  children: ReactNode
  maxHeight?: string | number
  sx?: SxProps<Theme>
}

export const TabScrollArea: FC<ITabScrollAreaProps> = ({
  children,
  maxHeight = TAB_CONTENT_MAX_HEIGHT,
  sx,
}) => (
  <Box
    sx={{
      maxHeight,
      ...scrollSx,
      ...sx,
    }}
  >
    {children}
  </Box>
)
